import React, { useState, useEffect } from 'react';
import BarHorizontale from '../tools/BarHorizontale';
import Footer from '../tools/Footer';
import ScroolTop from '../tools/ScroolTop';
import { API_URL } from '../../config';

function Newsletter() {
  const [subscribers, setSubscribers] = useState([]);
  const [loadingSubs, setLoadingSubs] = useState(true);
  const [subject, setSubject] = useState('');
  const [content, setContent] = useState('');
  const [sending, setSending] = useState(false);
  const [sendMsg, setSendMsg] = useState({ type: '', text: '' });

  const token = localStorage.getItem('token');

  useEffect(() => {
    fetchSubscribers();
  }, []);

  const fetchSubscribers = async () => {
    try {
      setLoadingSubs(true);
      const res = await fetch(`${API_URL}/api/newsletter/subscribers`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.status === 0) {
        setSubscribers(data.subscribers);
      }
    } catch {
      // silencieux
    } finally {
      setLoadingSubs(false);
    }
  };

  const handleSend = async (e) => {
    e.preventDefault();
    if (!subject.trim() || !content.trim()) {
      setSendMsg({ type: 'danger', text: 'Veuillez remplir tous les champs.' });
      return;
    }
    setSending(true);
    setSendMsg({ type: '', text: '' });
    try {
      const res = await fetch(`${API_URL}/api/newsletter/send`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ subject: subject.trim(), content: content.trim() }),
      });
      const data = await res.json();
      if (data.status === 0) {
        setSendMsg({ type: 'success', text: `Newsletter envoyée à ${data.count} abonné(s).` });
        setSubject('');
        setContent('');
      } else {
        setSendMsg({ type: 'danger', text: data.message || 'Erreur lors de l\'envoi.' });
      }
    } catch {
      setSendMsg({ type: 'danger', text: 'Erreur lors de l\'envoi.' });
    } finally {
      setSending(false);
    }
  };

  return (
    <>
      <div className="d-flex flex-column" id="content-wrapper">
        <div id="content">
          <BarHorizontale />
          <div className="container-fluid">
            <h3 className="text-dark mb-4">Newsletter</h3>

            {/* Composer une newsletter */}
            <div className="card shadow mb-4">
              <div className="card-header py-3">
                <p className="text-primary m-0 fw-bold">Envoyer une newsletter</p>
              </div>
              <div className="card-body">
                {sendMsg.text && (
                  <div className={`alert alert-${sendMsg.type}`} role="alert">
                    {sendMsg.text}
                  </div>
                )}
                <form onSubmit={handleSend}>
                  <div className="mb-3">
                    <label className="form-label fw-bold">Objet</label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Objet de la newsletter"
                      value={subject}
                      onChange={(e) => setSubject(e.target.value)}
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label fw-bold">Contenu</label>
                    <textarea
                      className="form-control"
                      rows="8"
                      placeholder="Contenu de la newsletter (HTML supporté)"
                      value={content}
                      onChange={(e) => setContent(e.target.value)}
                    />
                  </div>
                  <button type="submit" className="btn btn-primary" disabled={sending}>
                    {sending ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                        Envoi en cours...
                      </>
                    ) : (
                      <>Envoyer à tous les abonnés ({subscribers.length})</>
                    )}
                  </button>
                </form>
              </div>
            </div>

            {/* Liste des abonnés */}
            <div className="card shadow">
              <div className="card-header py-3 d-flex justify-content-between align-items-center">
                <p className="text-primary m-0 fw-bold">Abonnés ({subscribers.length})</p>
                <button className="btn btn-sm btn-outline-primary" onClick={fetchSubscribers} disabled={loadingSubs}>
                  <i className="fas fa-sync-alt"></i> Actualiser
                </button>
              </div>
              <div className="card-body">
                {loadingSubs ? (
                  <div className="text-center py-4">
                    <span className="spinner-border text-primary" role="status"></span>
                  </div>
                ) : subscribers.length === 0 ? (
                  <p className="text-muted text-center">Aucun abonné pour le moment.</p>
                ) : (
                  <div className="table-responsive">
                    <table className="table table-bordered table-hover">
                      <thead className="table-light">
                        <tr>
                          <th>#</th>
                          <th>Email</th>
                          <th>Date d'inscription</th>
                          <th>Statut</th>
                        </tr>
                      </thead>
                      <tbody>
                        {subscribers.map((sub, index) => (
                          <tr key={sub._id}>
                            <td>{index + 1}</td>
                            <td>{sub.email}</td>
                            <td>{new Date(sub.subscribedAt).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric' })}</td>
                            <td>
                              <span className={`badge ${sub.active ? 'bg-success' : 'bg-secondary'}`}>
                                {sub.active ? 'Actif' : 'Inactif'}
                              </span>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
      <ScroolTop />
    </>
  );
}

export default Newsletter;
